module.exports = __webpack_public_path__ + "img/instagram-stories-sticker-3.6d1edb48.png";